import React, { useContext, useEffect, useRef, useState } from "react";
import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import { getAbsConstraintsByAttributeID, getCFConstraintsByAttributeID } from "api/Attributes";
import { AttributeContext } from "../AttributeContext";
import {toast} from 'react-toastify'
import ViewMoreButton from "Components/Common/components/ViewMoreButton";
import CustomSearchBar from '../../../GMS/Products/components/CustomSearchBar'
import { ABS_ACTIVATE_MESSAGE, ABS_SELECTION, ABS_VALUE, CF_ACTIVATE_MESSAGE, CF_VALUE } from "../AttributeConstants";


export default function ABSView({title, id}) {
  const { editingItem } = useContext(AttributeContext);

  const [collapse, setCollapse] = useState(false);
  const [loading, setLoading] = useState({ status: "", message: "", });

  let [absDetails, setAbsDetails] = useState(null);
  let [attributeValuesCount, setAttributeValuesCount] = useState(0);
  let [valuesConstraints, setValueConstraints] = useState([]);
  const [search, setSearch] = useState("")

  const attrId = useRef(null)


  function handle_collapse() {
    setCollapse(!collapse);
  }

  const getAbsValues = (search, skip, reset) => {
    attrId.current = editingItem.id
    setLoading({status: "Loading", message: "Loading..."})

      getAbsConstraintsByAttributeID(editingItem.id, 10, skip, search)
      .then((res) => {
        const {value_constraints, ...rest} = res.constraints
        setAbsDetails(rest)
        if(value_constraints) setValueConstraints((prev) => {
          return (prev || !reset) ? [...prev, ...value_constraints] : value_constraints
        })
        setAttributeValuesCount(res.count)
        setLoading({
          status: "Success",
          message: ""
        })
      })
      .catch(err => {
        toast.error(err.message)
        setLoading({
          status: "Error",
          message: err.message
        })
      })
  }

  const getCfValues = (search, skip, reset) => {
    attrId.current = editingItem.id
    setLoading({status: "Loading", message: "Loading..."})
    getCFConstraintsByAttributeID(editingItem.id, 10, skip, search)
      .then((res) => {
        const {value_constraints, ...rest} = res.constraints
        setAbsDetails(rest)
        if(value_constraints) setValueConstraints((prev) => {
          return (prev || !reset) ? [...prev, ...value_constraints] : value_constraints
        })
        setAttributeValuesCount(res.count)
        setLoading({
          status: "Success",
          message: ""
        })
      })
      .catch(err => {
        toast.error(err.message)
        setLoading({
          status: "Error",
          message: err.message
        })
      })
  }

  useEffect(() => {
    if (title === ABS_SELECTION) {
      getAbsValues(search, undefined, true)
    } else {
      getCfValues(search, undefined, true);
    }
  }, [search]);

  useEffect(() => {
    setAbsDetails(null)
    setAttributeValuesCount(0)
    setValueConstraints([])
  }, [editingItem.id, search])

  useEffect(() => {
    if(!collapse || attrId.current === editingItem.id) return  
    setAbsDetails(null);
    setAttributeValuesCount(0);
    setValueConstraints([]);
    if (title === ABS_SELECTION) {
      getAbsValues();
    } else {
      getCfValues();
    }
  }, [collapse])


  const ABSDetailItem = ({ label, value, col = 6 }) => {
    return (
      <div className={`col-${col}`}>
        <div className="">
          {/* <Label message={value} fontSize={0.8} /> */}
          <li>
            <span className={"ms-0"}>
              {/* <strong>{value}: </strong> */}
              <Label message={`${label}`} fontSize={0.8} />
            </span>
            &nbsp;
            <br />
            <span className={"ms-0"}>
              <Label
                message={`${value}`}
                fontSize={0.8}
                fontWeight="600"
                color="#A1A1A1"
              />
              {/* {`${value}`} */}
            </span>
          </li>
        </div>
      </div>
    );
  };

  function getBool(val) {
    return !!JSON.parse(String(val).toLowerCase());
  }

  return (
    <>
      <div className="accordion" id={`accordionFlush${id}`}>
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#flush-collapse${id}`}
            aria-controls={`flush-collapse${id}`}
            style={Utils.borderStyle()}
          >
            <div>
              <Label message={title} />
            </div>
          </div>
          <div
            id={`flush-collapse${id}`}
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingCat"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
            { 
                loading.status === "Loading" && (
                  <div
                    className="alert alert-primary bg-white small p-2"
                    role="alert"
                  >
                    <span className="fas fa-circle-notch fa-spin" />
                    &nbsp;
                    <strong>{loading.message}</strong>
                  </div>
              )}

              { 
                loading.status === "Error" && (
                  <div
                    className="alert alert-danger small p-2"
                    role="alert"
                  >
                    <strong>{loading.message}</strong>
                  </div>
              )}

              {loading.status === "Success" &&  absDetails && (
                <>
                  <div
                    className="p-3 mb-3 bg-body rounded border-top-0 "
                    style={{ border: "1px solid #d6d8d9" }}
                  >
                    {absDetails && (
                      <div>
                        <ul className="list-unstyled">
                          <div className="container overflow-hidden">
                            <div className="row gy-3">
                              <ABSDetailItem
                                col={12}
                                label={title === ABS_SELECTION ? ABS_ACTIVATE_MESSAGE : CF_ACTIVATE_MESSAGE}
                                value={`${ title === ABS_SELECTION ? absDetails.abs_enabled ? "Yes" : "No" : absDetails.cf_enabled ? "Yes" : "No" }`}
                              />
                              <ABSDetailItem
                                col={12}
                                label="Display Name"
                                value={`${ title === ABS_SELECTION ?  absDetails?.abs_properties?.displayName ?? "-" : absDetails?.cf_properties?.displayName ?? "-" }`}
                              />
                              <ABSDetailItem
                                col={4}
                                label="Display Search"
                                value={`${ title === ABS_SELECTION ? absDetails.abs_properties && absDetails.abs_properties.displaySearch ? "Yes" : "No" : absDetails.cf_properties && absDetails.cf_properties.displaySearch ? "Yes" : "No"}`}
                              />
                              <ABSDetailItem
                                col={4}
                                label="Values per Row"
                                value={`${ title === ABS_SELECTION ? absDetails.abs_properties && absDetails.abs_properties.valuesPerRow :  absDetails.cf_properties && absDetails.cf_properties.valuesPerRow }`}
                              />
                              <ABSDetailItem
                                col={4}
                                label="Max Height"
                                value={`${ title === ABS_SELECTION ? absDetails.abs_properties && absDetails.abs_properties.maxHeight : absDetails.cf_properties && absDetails.cf_properties.maxHeight }`}
                              />
                              <ABSDetailItem
                                col={12}
                                label="Display Type"
                                value={`${ title === ABS_SELECTION ? absDetails.abs_properties && absDetails.abs_properties.DisplayType : absDetails.cf_properties && absDetails.cf_properties.DisplayType}`}
                              />
                              <div className="tw-w-min tw-inline">
                                <CustomSearchBar 
                                    placeholder="Search Attribute Values"
                                    handleSearchChange = {setSearch}
                                    value={search}
                                  />
                              </div>
                              {valuesConstraints &&
                                valuesConstraints.length > 0 && (
                                  <>
                                    <table className="table table-sm table-borderless mb-0 mt-4 ms-1">
                                      <thead>
                                        <tr className="mb-5">
                                          <th scope="col" style={{ fontSize: ".8rem" }}>Display</th>
                                          <th scope="col" style={{ fontSize: ".8rem" }}>Value</th>
                                          <th scope="col" style={{ fontSize: ".8rem" }}>{title === ABS_SELECTION ? ABS_VALUE : CF_VALUE}</th>
                                          {title === ABS_SELECTION ? <th scope="col" style={{ fontSize: ".8rem" }}>ABS Image Url</th> : null}
                                          {title === ABS_SELECTION ? <th scope="col" style={{ fontSize: ".8rem" }}>ABS Alt text</th> : null}
                                        </tr>
                                      </thead>
                                      <tbody className="align-middle">
                                        {valuesConstraints?.map(
                                          (singleValue, index) => {
                                            return (
                                              <tr key={index}>
                                                <td style={{ width: "10%" }}>
                                                  <div className="form-check form-switch mb-3 mr-2">
                                                    <input className="form-check-input" type="checkbox" disabled={true} name="abs_show" id={index} checked={getBool(title === ABS_SELECTION ? singleValue.abs_show : singleValue.cf_show)} value={getBool(title === ABS_SELECTION ? singleValue.abs_show : singleValue.cf_show)} onChange={(e) => null}/>
                                                  </div>
                                                </td>
                                                <td style={{fontSize: ".8rem", fontWeight: "600",}}> {singleValue.value}</td>
                                                <td className="mb-2">
                                                  <input type="text" disabled={true} className="form-control" style={{ padding: "1", fontSize: ".8rem", fontWeight: "600",}} name="abs_display_value" value={title === ABS_SELECTION ? singleValue.abs_display_value : singleValue.cf_display_value} placeholder={title === ABS_SELECTION ? ABS_VALUE : CF_VALUE} onChange={(e) => null} />
                                                </td>
                                                {title === ABS_SELECTION ? <td className="mb-2">
                                                  <input type="text" disabled={true} className="form-control" name="abs_image_url" style={{padding: "1",fontSize: ".8rem",fontWeight: "600",}} value={singleValue.abs_image_url} placeholder="ABS Image Url starts with https:// or http://" onChange={(e) => {}} />
                                                </td> : null}
                                                {title === ABS_SELECTION ?<td className="mb-2">
                                                  <input type="text" disabled={true} className="form-control" style={{ padding: "1", fontSize: ".8rem", fontWeight: "600",}} name="abs_alt_text" value={ singleValue.abs_alt_text } placeholder="ABS Alt text" onChange={(e) => null} />
                                                </td> : null}
                                              </tr>
                                            );
                                          }
                                        )}
                                      </tbody>
                                    </table>
                                  </>
                                )}
                                <ViewMoreButton
                                  condition = {valuesConstraints.length < attributeValuesCount}
                                  state = {valuesConstraints.length >= attributeValuesCount}
                                  handleClick = {() => title === ABS_SELECTION ?  getAbsValues(search, valuesConstraints.length) : getCfValues(search, valuesConstraints.length)}
                                />
                            </div>
                          </div>
                        </ul>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}